let _audioContext = null;
let _audioBuffer = null;

/**
 * Initialize AudioContext and pre-decode notification sound into memory on user gesture.
 */
export async function unlockAudio() {
  try {
    if (typeof window === 'undefined') return;
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;

    if (!_audioContext) {
      _audioContext = new AudioCtx();
    }

    if (_audioContext.state === 'suspended') {
      await _audioContext.resume();
    }

    if (!_audioBuffer) {
      const response = await fetch('/mixkit-correct-answer-tone-2870.wav');
      const arrayBuffer = await response.arrayBuffer();
      _audioBuffer = await _audioContext.decodeAudioData(arrayBuffer);
      console.info(
        '[OneSignal] Notification audio preloaded into Web Audio API memory ✓',
      );
    }
  } catch {
    // Non-critical — HTML5 Audio fallback will be used if Web Audio fails.
  }
}

/**
 * Play the notification sound when a push notification is received.
 */
export function playNotificationSound() {
  // Method 1: Web Audio API (pre-buffered, zero-latency, bypasses HTML5 audio element lock)
  try {
    if (_audioContext && _audioBuffer) {
      if (_audioContext.state === 'suspended') {
        _audioContext.resume().catch(() => {});
      }
      const source = _audioContext.createBufferSource();
      source.buffer = _audioBuffer;
      const gainNode = _audioContext.createGain();
      gainNode.gain.value = 1.0;
      source.connect(gainNode);
      gainNode.connect(_audioContext.destination);
      source.start(0);
      console.info('[OneSignal] Sound played via Web Audio API 🔊');
      return;
    }
  } catch (err) {
    console.warn(
      '[OneSignal] Web Audio play failed, trying HTML5 Audio fallback:',
      err,
    );
  }

  // Method 2: Fresh HTML5 Audio instance fallback
  try {
    const audio = new Audio('/mixkit-correct-answer-tone-2870.wav');
    audio.volume = 1.0;
    const playPromise = audio.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.info('[OneSignal] Sound played via HTML5 Audio 🔊');
        })
        .catch((err) => {
          console.warn(
            '[OneSignal] HTML5 Audio play warning (click anywhere to unlock):',
            err?.message || err,
          );
        });
    }
  } catch (err) {
    console.error('[OneSignal] Notification sound playback error:', err);
  }
}

// Expose on window for easy developer/user console testing
if (typeof window !== 'undefined') {
  window.__playTestNotificationSound = playNotificationSound;
}
